import type { Theme } from '@mui/material';

export const styles = {
  textUser: {
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: 500,
    whiteSpace: 'pre-wrap',
    pt: 0.5,
  },

  textBubbleUser: (theme: Theme) => ({
    ...theme.typography.body4,
    lineHeight: '20px',
    maxWidth: '350px',
    padding: 2.25,
    whiteSpace: 'pre-wrap',
    bgcolor: theme.colors.neutral[100],
    borderRadius: '20px',
    borderBottomRightRadius: 0,
    marginLeft: 'auto',
  }),

  iconBot: {
    justifyContent: 'flex-end',
    width: '42px',
    mr: 2.75,

    svg: {
      width: '42px',
      height: '42px',
    },
  },

  textBot: (theme: Theme) => ({
    ...theme.typography.body4,
    whiteSpace: 'pre-wrap',
    '& a': {
      color: theme.colors.primary[500],
      textDecoration: 'underline',
    },
  }),

  textBubbleBot: (theme: Theme) => ({
    ...theme.typography.body4,
    lineHeight: '20px',
    maxWidth: '350px',
    padding: 2.25,
    whiteSpace: 'pre-wrap',
    bgcolor: theme.colors.secondary[200],
    borderRadius: '20px',
    borderBottomLeftRadius: 0,
    '& a': {
      color: theme.colors.primary[500],
      textDecoration: 'underline',
    },
  }),

  highlight: (theme: Theme) => ({
    color: theme.colors.primary[500],
    fontWeight: theme.typography.fontWeightBold,
  }),
};
